export default __webpack_public_path__ + "static/media/premium4.81b64a20.png";